// routes/router.tsx
import {createBrowserRouter, Navigate} from 'react-router-dom';
import App from '../App';
import LoginPage from '../pages/LoginPage';
import { authLoader } from './loaders/authLoader';
import LayoutPage from '../pages/LayoutPage/LayoutPage';
import PreparingPage from '../pages/PreparingPage';
import CashManagePage from '../pages/CashManagePage';
import {SystemBatchRunPage} from "../pages/SystemBatchRunPage";
import {CashPeriodPage} from "../pages/CashPeriodPage";
import {PointAdjustPage} from "../pages/PointAdjustPage";
import {NoticePage} from "../pages/NoticePage";
import {FCMMessagePage} from "../pages/FCMMessagePage";
import BaechaGroupDonePage from "../pages/BaechaGroupDonePage";
import BaechaListPage from "../pages/BaechaListPage";
import UserListPage from "../pages/UserListPage";
import ModooCarListPage from "../pages/ModooCarListPage";
import {SystemGeoSetupPage} from "../pages/SystemGeoSetupPage";
import BaechaGroupListPage from "../pages/BaechaGroupListPage";
import SystemSubscriptionAckPage from "../pages/SystemSubscriptionAckPage";
import SubscriptionListPage from "../pages/SubscriptionListPage";
import BaechaListPage2 from "../pages/BaechaListPage2";

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Navigate to="login" replace />,
      },
      {
        path: 'login',
        element: <LoginPage />
      },
      {
        path: 'app',
        loader: authLoader,
        element: <LayoutPage />,
        children: [
          // 비즈니스
          {
            path: 'business/cashManage', // 캐쉬 요청
            element: <CashManagePage/>,
          },
          {
            path: 'business/cashManage/:id',
            element: <CashManagePage/>,
          },
	        {
		        path: 'business/userList', // 회원 조회
		        element: <UserListPage/>,
	        },
	        {
		        path: 'business/userList/:id',
		        element: <UserListPage/>,
	        },
	        {
		        path: 'business/carList', // 모배 차량 조회
		        element: <ModooCarListPage/>,
	        },
          {
            path: 'business/cashPeriod', // 일별 입출금
            element: <CashPeriodPage />
          },
          {
            path: 'business/pointAdjust', // 점수 조정
            element: <PointAdjustPage />
          },
          {
            path: 'business/cashStatics',
            element: <PreparingPage/>
          },
          {
            path: 'business/notice', // 공지사항
            element: <NoticePage/>
          },
          {
            path: 'business/fcmMessage', // FCM 메시지
            element: <FCMMessagePage/>
          },
          {
            path: 'business/fcmMessage',
            element: <FCMMessagePage/>
          },
          {
            path: 'business/baechaGroupDone',
            element: <BaechaGroupDonePage/>
          },
          {
            path: 'business/baechaList', // 배차 조회
            element: <BaechaListPage/>
          },
          {
            path: 'business/baechaList2', // 배차 조회
            element: <BaechaListPage2/>
          },
          {
            path: 'business/subscriptionList', // 구독 조회
            element: <SubscriptionListPage/>
          },
          // {
          //   path: 'business/baechaGroupList',
          //   element: <BaechaGroupListPage/>
          // },

          // 시스템
          {
            path: 'system/batchLog',
            element: <PreparingPage/>
          },
          {
            path: 'system/batchRun', // 배치 실행
            element: <SystemBatchRunPage/>
          },
	        {
		        path: 'system/geoSetup', // 주소 업로드
		        element: <SystemGeoSetupPage/>
	        },
          {
            path: 'system/subscription/ack', // 구독 ack 처리
            element: <SystemSubscriptionAckPage/>
          },
        ]
      },
    ],
    errorElement: <div>error</div>
  },
]);

export default router;
